import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type AddOptimizationLinesDto = ClientInferResponseBody<
  typeof contract.optimizations.addLines
>;

export const addOptimizationLines = async ({
  optimizationId,
  lineIds,
}: {
  optimizationId: string;
  lineIds: string[];
}): Promise<AddOptimizationLinesDto> => {
  const response = await api.optimizations.addLines.mutation({
    params: { id: optimizationId },
    body: { lineIds },
  });

  if (response.status !== 200) {
    throw new ApiError("Error adding optimization lines", response.status, response.body);
  }

  return response.body;
};
